"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useOfferApi = useOfferApi;
const react_router_1 = require("react-router");
const react_redux_1 = require("react-redux");
const Api = __importStar(require("@src/api"));
const moment_1 = __importDefault(require("moment"));
const date_fns_1 = require("date-fns");
const types_1 = require("@src/types");
const react_ga_1 = __importDefault(require("@src/helpers/react-ga"));
const gtm_1 = __importDefault(require("@src/helpers/gtm"));
const formatWorkingHours_1 = require("@src/helpers/formatWorkingHours");
const get_timezone_from_offset_1 = require("@src/backend/helpers/get-timezone-from-offset");
const react_query_1 = require("react-query");
const queries_1 = require("@src/types/queries");
const use_offer_notifications_1 = require("./use-offer-notifications");
const offer_model_1 = require("./offer-model");
const admin_context_1 = require("../../admin-context");
function useOfferApi(setIsLoading) {
    const queryClient = (0, react_query_1.useQueryClient)();
    const history = (0, react_router_1.useHistory)();
    const { setIsOpenNotEnoughCreditsDialog } = (0, admin_context_1.useAdminContextValue)();
    // @ts-ignore
    const companyAddress = (0, react_redux_1.useSelector)(state => state.admin.company.address);
    const { showOfferCreatedNotification, showOfferEditedNotification, showNotVerifiedNotification, showGeneralErrorNotification, showDraftSavedNotification, showAlreadyPublishedNotification, } = (0, use_offer_notifications_1.useOfferNotifications)();
    function handleCreateOrUpdateOfferError(statusCode) {
        if (statusCode === 403) {
            showNotVerifiedNotification();
        }
        else if (statusCode === 400) {
            setIsOpenNotEnoughCreditsDialog(true);
            react_ga_1.default.event({
                category: 'Company',
                action: 'Offers limit reached',
                label: 'Offer Post',
            });
            gtm_1.default.dataLayer({
                event: 'company_offer_limit_reached',
                category: 'company',
            });
        }
        else {
            showGeneralErrorNotification();
        }
    }
    async function createOffer({ offerBasicInfo, offerAssets, offerPaymentType, isActive, isDraft, isHiringProcessActive, shouldSaveDraftOnUnmountRef, }) {
        var _a, _b;
        setIsLoading(true);
        try {
            const { workingTimeFrom, workingTimeTo, timezone } = offerBasicInfo;
            const clientOffset = (0, moment_1.default)().utcOffset();
            // fallback in case of missing timezone in DB (address TZ => company address TZ => client TZ)
            const fallbackTimezone = timezone || (0, get_timezone_from_offset_1.getSingleTimezoneFromArray)((0, get_timezone_from_offset_1.getOffsetTimezoneNames)(clientOffset));
            const { timeFrom, timeTo } = (0, formatWorkingHours_1.formatWorkingHours)({
                workingTimeFrom,
                workingTimeTo,
                timezone: fallbackTimezone,
            });
            const createdOfferId = await Api.Offer.createOffer({
                ...offerBasicInfo,
                companyBillingProfileId: offerPaymentType.billingProfileId,
                paymentType: offerPaymentType.paymentType,
                isActive,
                isDraft,
                isHiringProcessActive,
                turnUpDate: (0, offer_model_1.getFormTurnUpDate)(offerBasicInfo),
                workingTimeFrom: timeFrom === null || timeFrom === void 0 ? void 0 : timeFrom.format('HH:mm'),
                workingTimeTo: timeTo === null || timeTo === void 0 ? void 0 : timeTo.format('HH:mm'),
                jobArea: (_a = offerBasicInfo.jobArea) === null || _a === void 0 ? void 0 : _a.map(area => area.id),
                galleries: (0, offer_model_1.prepareOfferAssetGalleries)(offerAssets[types_1.EOfferAssetsFormField.galleries] || null),
                isIndefinite: (0, offer_model_1.getIsIndefiniteStatus)(offerBasicInfo[types_1.EOfferBasicInfoFormField.isIndefinite] || null),
            });
            showOfferCreatedNotification();
            react_ga_1.default.event({
                category: 'Company',
                action: 'Offer post',
                label: offerBasicInfo.title,
            });
            queryClient.invalidateQueries(queries_1.Queries.getCompany);
            gtm_1.default.dataLayer({
                event: 'company_create_offer',
                category: 'company',
            });
            if (shouldSaveDraftOnUnmountRef) {
                shouldSaveDraftOnUnmountRef.current = false;
            }
            return createdOfferId;
        }
        catch (err) {
            const statusCode = (_b = err.response) === null || _b === void 0 ? void 0 : _b.status;
            handleCreateOrUpdateOfferError(statusCode);
            console.error(err);
        }
        finally {
            setIsLoading(false);
        }
    }
    async function updateOffer({ offerId, offerPaymentType, offerBasicInfo, offerAssets, isBeingPublished, isActive, isDraft, isHiringProcessActive, shouldSaveDraftOnUnmountRef, }) {
        var _a, _b;
        setIsLoading(true);
        try {
            const { workingTimeFrom, workingTimeTo, timezone } = offerBasicInfo;
            const clientOffset = (0, moment_1.default)().utcOffset();
            // fallback in case of missing timezone in DB (address TZ => company address TZ => client TZ)
            const fallbackTimezone = timezone || (0, get_timezone_from_offset_1.getSingleTimezoneFromArray)((0, get_timezone_from_offset_1.getOffsetTimezoneNames)(clientOffset));
            const { timeFrom, timeTo } = (0, formatWorkingHours_1.formatWorkingHours)({
                workingTimeFrom,
                workingTimeTo,
                timezone: fallbackTimezone,
            });
            await Api.Offer.updateOffer(offerId, {
                ...offerBasicInfo,
                companyBillingProfileId: offerPaymentType.billingProfileId,
                paymentType: offerPaymentType.paymentType,
                turnUpDate: (0, offer_model_1.getFormTurnUpDate)(offerBasicInfo),
                isActive,
                isDraft,
                isHiringProcessActive,
                workingTimeFrom: timeFrom === null || timeFrom === void 0 ? void 0 : timeFrom.format('HH:mm'),
                workingTimeTo: timeTo === null || timeTo === void 0 ? void 0 : timeTo.format('HH:mm'),
                jobArea: (_a = offerBasicInfo.jobArea) === null || _a === void 0 ? void 0 : _a.map(area => area.id),
                galleries: (0, offer_model_1.prepareOfferAssetGalleries)(offerAssets[types_1.EOfferAssetsFormField.galleries] || null),
                isIndefinite: (0, offer_model_1.getIsIndefiniteStatus)(offerBasicInfo[types_1.EOfferBasicInfoFormField.isIndefinite] || null),
            });
            await queryClient.invalidateQueries(queries_1.Queries.getMyOffers);
            if (isBeingPublished) {
                gtm_1.default.dataLayer({
                    event: 'company_create_offer',
                    category: 'company',
                });
                queryClient.invalidateQueries(queries_1.Queries.getCompany);
            }
            if (shouldSaveDraftOnUnmountRef) {
                shouldSaveDraftOnUnmountRef.current = false;
            }
            showOfferEditedNotification();
            return true;
        }
        catch (err) {
            const statusCode = (_b = err.response) === null || _b === void 0 ? void 0 : _b.status;
            handleCreateOrUpdateOfferError(statusCode);
            console.error(err);
            return false;
        }
        finally {
            setIsLoading(false);
        }
    }
    // async function fetchScrapedOfferBasicInfo(scrapingLink: string) {
    // 	try {
    // 		gtm.dataLayer({
    // 			event: 'company_scrape_offer',
    // 			category: 'company',
    // 		})
    // 		const scrapedOfferBaiscInfoValues = await Api.Offer.fetchOfferFromExternalLink(scrapingLink)
    // 		scrapedOfferBaiscInfoValues.deadline = moment().add(31, 'days').endOf('day')
    // 		if (!scrapedOfferBaiscInfoValues.address) {
    // 			scrapedOfferBaiscInfoValues.address = {
    // 				country: companyAddress?.country as Alpha2Code,
    // 				formatted_address: companyAddress?.formattedAddress,
    // 				google_place_id: companyAddress?.googlePlaceId,
    // 			}
    // 		}
    // 		if (typeof scrapedOfferBaiscInfoValues.turnUpDate === 'string') {
    // 			scrapedOfferBaiscInfoValues.turnUpDate = moment(scrapedOfferBaiscInfoValues.turnUpDate)
    // 		}
    // 		showScrapingSuccessfullNotification()
    // 		return scrapedOfferBaiscInfoValues
    // 	} catch (err) {
    // 		console.error(err)
    // 		throw err // handle error later in context init
    // 	}
    // }
    const fetchOfferInitialValuesForEdit = async ({ offerId, isEditingDuplicateOffer, slug, }) => {
        var _a;
        try {
            const splittedSlug = slug.split('-');
            const slugWithoutOfferId = splittedSlug.slice(0, splittedSlug.length - 1).join('-');
            const offerData = await Api.Offer.getOffer(offerId, slugWithoutOfferId, true);
            const { isActive } = offerData;
            const companyAddressValues = {
                country: companyAddress.country,
                formatted_address: companyAddress.formattedAddress,
                google_place_id: companyAddress.googlePlaceId,
            };
            const { offerBasicInfo, offerAssets, offerPaymentType } = (0, offer_model_1.transformIncomingOfferData)(offerData);
            if (!offerBasicInfo.address) {
                offerBasicInfo.address = companyAddressValues;
            }
            if (isEditingDuplicateOffer) {
                offerBasicInfo[types_1.EOfferBasicInfoFormField.deadline] = (0, moment_1.default)((0, date_fns_1.add)(new Date(), { days: 31 }));
            }
            return { offerBasicInfo, offerAssets, isActive: Boolean(isActive), offerPaymentType };
        }
        catch (err) {
            console.error(err);
            const statusCode = (_a = err.response) === null || _a === void 0 ? void 0 : _a.status;
            if (statusCode === 403 || statusCode === 404) {
                history.replace('/error');
            }
            else {
                showGeneralErrorNotification();
            }
            return { offerBasicInfo: {}, offerAssets: {}, isActive: false, offerPaymentType: {} };
        }
    };
    const fetchDraftOfferValues = async (draftSlug) => {
        try {
            const splittedSlug = draftSlug.split('-');
            const offerId = parseInt(splittedSlug.pop(), 10);
            const offerData = await Api.Offer.getOffer(offerId, splittedSlug.join('-'), true);
            const { offerBasicInfo, offerAssets, offerPaymentType } = (0, offer_model_1.transformIncomingOfferData)(offerData, companyAddress === null || companyAddress === void 0 ? void 0 : companyAddress.timezone);
            if (!offerBasicInfo.address) {
                offerBasicInfo.address = {
                    country: companyAddress === null || companyAddress === void 0 ? void 0 : companyAddress.country,
                    formatted_address: companyAddress === null || companyAddress === void 0 ? void 0 : companyAddress.formattedAddress,
                    google_place_id: companyAddress === null || companyAddress === void 0 ? void 0 : companyAddress.googlePlaceId,
                };
            }
            return { offerBasicInfo, offerAssets, offerPaymentType };
        }
        catch (err) {
            console.error(err);
            showGeneralErrorNotification();
        }
    };
    const saveOfferDraft = async ({ draftSlug, offerBasicInfo, offerPaymentType, offerAssets, }) => {
        var _a, _b, _c, _d;
        try {
            const turnUpDate = (0, offer_model_1.getFormTurnUpDate)(offerBasicInfo);
            const { workingTimeFrom, workingTimeTo, timezone } = offerBasicInfo;
            const clientOffset = (0, moment_1.default)().utcOffset();
            // fallback in case of missing timezone in DB (address TZ => company address TZ => client TZ)
            const fallbackTimezone = timezone || (companyAddress === null || companyAddress === void 0 ? void 0 : companyAddress.timezone) || (0, get_timezone_from_offset_1.getSingleTimezoneFromArray)((0, get_timezone_from_offset_1.getOffsetTimezoneNames)(clientOffset));
            const { timeFrom, timeTo } = (0, formatWorkingHours_1.formatWorkingHours)({
                workingTimeFrom,
                workingTimeTo,
                timezone: fallbackTimezone,
            });
            const offerToSave = {
                ...offerBasicInfo,
                companyBillingProfileId: offerPaymentType.billingProfileId,
                paymentType: offerPaymentType.paymentType,
                driverLicences: (_a = offerBasicInfo.driverLicences) === null || _a === void 0 ? void 0 : _a.filter(licence => licence.driverLicence || licence.mileage),
                languages: (_b = offerBasicInfo.languages) === null || _b === void 0 ? void 0 : _b.filter(language => language.languageCode || language.languageLevel),
                jobArea: (_c = offerBasicInfo.jobArea) === null || _c === void 0 ? void 0 : _c.map(area => area.id),
                turnUpDate,
                workingTimeFrom: timeFrom === null || timeFrom === void 0 ? void 0 : timeFrom.format('HH:mm ZZ'),
                workingTimeTo: timeTo === null || timeTo === void 0 ? void 0 : timeTo.format('HH:mm'),
                galleries: (0, offer_model_1.prepareOfferAssetGalleries)(offerAssets[types_1.EOfferAssetsFormField.galleries] || null),
                isIndefinite: (0, offer_model_1.getIsIndefiniteStatus)(offerBasicInfo[types_1.EOfferBasicInfoFormField.isIndefinite] || null),
            };
            if (draftSlug) {
                const offerId = parseInt(draftSlug.split('-').pop(), 10);
                await Api.Offer.updateOffer(offerId, {
                    ...offerToSave,
                    isActive: false,
                    isDraft: true,
                    isHiringProcessActive: false,
                });
            }
            else {
                await Api.Offer.postOfferDraft(offerToSave);
            }
            showDraftSavedNotification();
        }
        catch (err) {
            const statusCode = (_d = err.response) === null || _d === void 0 ? void 0 : _d.status;
            if (statusCode === 403) {
                showNotVerifiedNotification();
            }
            else if (statusCode === 409) {
                showAlreadyPublishedNotification();
            }
            else {
                showGeneralErrorNotification();
            }
            console.error(err);
        }
    };
    return {
        createOffer,
        updateOffer,
        // fetchScrapedOfferBasicInfo,
        fetchOfferInitialValuesForEdit,
        fetchDraftOfferValues,
        saveOfferDraft,
    };
}
